<template>
  <span class="d-highlight-text">
    <span
      v-for="(part, idx) in textParts"
      :key="idx"
    >
      <mark v-if="part.isHighlighted">{{ part.text }}</mark>
      <span v-else>{{ part.text }}</span>
    </span>
  </span>
</template>

<script>
export default {
  props: {
    highlight: {
      type: String,
      required: true,
    },
    text: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    textParts: [],
  }),
  watch: {
    highlight: function() {
      this.configureTextParts();
    },
    text: function() {
      this.configureTextParts();
    },
  },
  mounted() {
    this.configureTextParts();
  },
  methods: {
    configureTextParts() {
      const textParts = [];

      let currentText = this.text.toLowerCase();
      let highlightIndex = currentText.indexOf(this.highlight.toLowerCase());
      let parsedIndex = 0;

      while (highlightIndex > -1) {
        let prevText = '';

        if (highlightIndex > 0) {
          prevText = this.text.substring(parsedIndex, (parsedIndex + highlightIndex));

          textParts.push({
            isHighlighted: false,
            text: prevText,
          });
        }

        const textMatch = this.text.substring((parsedIndex + highlightIndex), (parsedIndex + highlightIndex + this.highlight.length));

        textParts.push({
          isHighlighted: true,
          text: textMatch,
        });

        currentText = currentText.substring(prevText.length + this.highlight.length);
        parsedIndex += prevText.length + this.highlight.length;
        highlightIndex = currentText.indexOf(this.highlight.toLowerCase());
      }

      textParts.push({
        isHighlighted: false,
        text: this.text.substring(parsedIndex),
      });

      this.$set(this, 'textParts', textParts);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@dui-styles/base";

.d-highlight-text {
  mark {
    background-color: initial;
    color: initial;
    font-weight: $base-weight-bold;
  }
}
</style>
